
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 34 34"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd"}},[_c('path',{attrs:{"d":"M29.467 8.612l-7.359-7.358A.86.86 0 0021.497 1H5.144a.865.865 0 00-.865.865v30.27c0 .478.388.865.865.865h23.712a.865.865 0 00.865-.865V9.223c0-.23-.092-.45-.254-.611zm-8.08-5.634l6.325 6.325h-6.325V2.978zm6.604 28.292H6.009V2.73h13.648v7.438c0 .478.387.865.865.865h7.469V31.27z"}}),_c('path',{attrs:{"d":"M9.75 10.6h6.262a.432.432 0 000-.864H9.75a.431.431 0 100 .864zm-.433 3.468c0 .239.194.432.432.432h14.5a.432.432 0 000-.864h-14.5a.433.433 0 00-.432.432zm2.213 5.874H9.035v6.763h.892v-2.647h1.593c.765 0 1.353-.177 1.763-.532.41-.355.615-.861.615-1.516 0-.624-.209-1.123-.629-1.501-.42-.378-.999-.567-1.739-.567zm1.096 3.048c-.254.225-.62.338-1.097.338H9.927v-2.657h1.654c.443.008.791.134 1.046.376.253.242.381.565.381.968-.001.426-.128.751-.382.975zm5.881-2.658c-.452-.26-.973-.39-1.561-.39h-1.909v6.764h1.872c.607-.006 1.139-.138 1.596-.395.456-.257.808-.625 1.054-1.105s.369-1.04.369-1.677v-.432c-.003-.622-.128-1.174-.375-1.654a2.625 2.625 0 00-1.046-1.111zm.539 3.174c0 .79-.191 1.399-.573 1.828-.382.427-.918.641-1.605.641h-.938v-5.304h1.04c.663.006 1.175.222 1.536.648.361.426.541 1.024.541 1.792v.395zm2.229 3.199h.892v-2.986h2.838v-.73h-2.838v-2.317h3.299v-.73h-4.191"}})])])
          )
        }
      }
    